
document.querySelectorAll('.product-info-tabs-elem').forEach((tab)=>{
    tab.querySelector('.product-info-tabs-elem-title').addEventListener('click',()=>{
      let hiddenEl = tab.querySelector('.product-info-tabs-elem-hidden')
      if (hiddenEl.style.display === 'none') {
        tab.querySelector('.description_title_icon').style.transform = 'rotateZ(45deg)'
        hiddenEl.style.display = 'block'
      }else{
        tab.querySelector('.description_title_icon').style.transform = 'rotateZ(0deg)'
        hiddenEl.style.display = 'none'
      }
    })

   })

   document.querySelector('.product-info-tabs-elem-upsell').addEventListener('click', () =>{
    if(document.querySelector('.upsells_container').style.display === 'none'){
        document.querySelector('.upsells_container').style.display = 'flex'
        document.querySelector('.product-info-tabs-elem-upsell .description_title_icon').style.transform = 'rotateZ(45deg)'
   
    }else{
        document.querySelector('.upsells_container').style.display = 'none'
        document.querySelector('.product-info-tabs-elem-upsell .description_title_icon').style.transform = 'rotateZ(0deg)'
    }
   })


